import NavigationModulePage from './NavigationModulePage';

export default NavigationModulePage;
